function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.regexp.exec.js";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import { Button } from '@finect/tabular-core/Button';
import { H6 } from '@finect/tabular-core/Headings';
import { TextButton } from '@finect/tabular-core/TextButton';
import { Flex } from '@finect/tabular-core/Flex';
import { deepEqual } from '@finect/front-utils/deepEqual';
import { Modal, ModalHeader, ModalTitle, ModalSubtitle, ModalInner, ModalFooter, ModalBody } from '../../../Modal';
import { Chip } from '../../../Chip';
import { Block, BodyInner, Badge } from './partials';
export var CustomizeColumns = function (_React$Component) {
  _inherits(CustomizeColumns, _React$Component);
  var _super = _createSuper(CustomizeColumns);
  function CustomizeColumns() {
    var _this;
    _classCallCheck(this, CustomizeColumns);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "handleChipClick", function (id) {
      var value = _this.props.value;
      var newValue = value.includes(id) ? value.filter(function (item) {
        return item !== id;
      }) : [].concat(_toConsumableArray(value), [id]);
      _this.props.onChange(newValue);
    });
    _defineProperty(_assertThisInitialized(_this), "handleSubmit", function () {
      _this.props.onSubmit(_this.props.value);
    });
    _defineProperty(_assertThisInitialized(_this), "handleRestore", function () {
      _this.props.onChange(_this.props.initialSelection);
    });
    _defineProperty(_assertThisInitialized(_this), "handleClose", function () {
      _this.props.onClose();
    });
    return _this;
  }
  _createClass(CustomizeColumns, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        title = _this$props.title,
        subtitle = _this$props.subtitle,
        options = _this$props.options,
        _this$props$value = _this$props.value,
        value = _this$props$value === void 0 ? [] : _this$props$value,
        maxCustomizationColumns = _this$props.maxCustomizationColumns;
      return React.createElement(Modal, {
        variant: "fullContainer",
        onClose: this.handleClose
      }, React.createElement(ModalInner, null, React.createElement(ModalHeader, {
        as: Flex,
        justify: "space-between",
        wrap: "wrap"
      }, React.createElement("div", null, title && React.createElement("div", null, React.createElement(ModalTitle, null, title)), maxCustomizationColumns !== 0 && React.createElement(ModalTitle, null, "Has seleccionado", ' ', React.createElement(Badge, {
        value: value.length,
        max: maxCustomizationColumns
      }, value.length, " de ", maxCustomizationColumns), ' ', "campos"), React.createElement(ModalSubtitle, null, subtitle))), React.createElement(ModalBody, null, React.createElement(BodyInner, null, options.map(function (group, index) {
        return React.createElement(Block, {
          key: index
        }, React.createElement("div", null, React.createElement(H6, null, group.title)), React.createElement("div", null, group.options.map(function (option, optionIdex) {
          return React.createElement(Chip, {
            key: optionIdex,
            value: option.title,
            isActive: value.includes(option.id),
            onAction: function onAction() {
              _this2.handleChipClick(option.id);
            }
          });
        })));
      }))), React.createElement(ModalFooter, null, React.createElement("div", null, !deepEqual(this.props.value, this.props.initialSelection) ? React.createElement(TextButton, {
        terciary: true,
        width: "auto",
        onClick: this.handleRestore
      }, "Restablecer") : null, React.createElement(Button, {
        secondary: true,
        width: "auto",
        disabled: !value.length,
        onClick: this.handleSubmit
      }, "Guardar")))));
    }
  }]);
  return CustomizeColumns;
}(React.Component);